//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required } from "@/utils/validations.js";
import { noValidation } from "@/utils/validations.js";

export default {
  name: "TraitsTab",
  props: ["value"],
  components: {},
  mounted: function () {
    this.validateData();
  },
  computed: {
  },
  updated: function () {
    this.$nextTick(function () {
      this.validateData();
    });
  },
  data: () => ({
    tab: "traits",
    type: null,
    validForm: null,
  }),
  methods: {
    required,
    noValidation,
    hierarchyValidation: function (index) {
      if (!index) {
        return this.required("Campo obrigatório");
      } else {
        return this.noValidation();
      }
    },
    validateData: function () {
      this.$refs.form.validate().then((success) => {
        if (success) {
          this.validForm = true;
          this.$emit("form-valid", this.validForm);
        } else {
          this.validForm = false;
          this.$emit("form-invalid", this.validForm);
        }
      });
    },
    updateData: function () {
      this.$emit("value", this.value);
    },
  },
};
